import React from 'react';
import './skeletonloader.scss';

export default function Skeletonloader() {
  return (
    <>
      <div className="image-skeleton-loader-main">
        <div className="image-skeleton-loader"></div>
      </div>
    </>
  );
}
